import React from 'react';
export function Footer() {
  return <footer className="border-t border-slate-200 bg-white" data-id="element-25" data-mp="1k5nvwdmy3bzc">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-center sm:flex-row sm:text-left lg:px-10" data-id="element-26" data-mp="eniqksgvhnbv">
        <p className="text-sm text-slate-500" data-id="element-27" data-mp="ao9xzqxkjvhw">
          Copyright &copy; {new Date().getFullYear()} Elijah Gerson. All rights reserved.
        </p>
        <p className="text-xs font-medium uppercase tracking-[0.14em] text-slate-400" data-id="element-28" data-mp="o9bjw4ekz9h">
          Director-Level Executive, Energy Transition &amp; Strategy Leader
        </p>
      </div>
    </footer>;
}